var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTakeAgreeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    rx: 10,
    fill: "#1AAEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9678 44.5215L31.2592 48.6181C31.9419 49.3008 33.4781 49.6422 34.5023 49.6422H40.9885C43.0367 49.6422 45.2557 48.106 45.7678 46.0577L49.8643 33.5974C50.7178 31.2077 49.1816 29.1594 46.6212 29.1594H39.7936C38.7695 29.1594 37.916 28.306 38.0867 27.1112L38.9402 21.6491C39.2816 20.1129 38.2574 18.406 36.7212 17.8939C35.3557 17.3819 33.6488 18.0646 32.966 19.0888L25.9678 29.5008",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2627 44.5215V27.7939C17.2627 25.4043 18.2868 24.5508 20.6765 24.5508H22.3834C24.773 24.5508 25.7972 25.4043 25.7972 27.7939V44.5215C25.7972 46.9112 24.773 47.7646 22.3834 47.7646H20.6765C18.2868 47.7646 17.2627 46.9112 17.2627 44.5215Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeAgreeIcon);
export default __webpack_public_path__ + "static/media/takeAgreeIcon.493c8dec617547c925de8b45e8f9f5fa.svg";
export { ForwardRef as ReactComponent };